/** The two class strings the admin tables repeated eight times over. */
export const TH =
  "px-6 bg-slate-50 text-slate-500 align-middle border border-solid border-slate-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left";

export const TD =
  "border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4";

export const TD_HEAD = `${TD} text-left`;

export const BTN_PRIMARY =
  "bg-indigo-500 text-white active:bg-indigo-600 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none ease-linear transition-all duration-150 disabled:opacity-40";

/** Shared dialog chrome, so every modal keeps the look the two forms set. */
export const DIALOG_BACKDROP =
  "fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in";

export const DIALOG_PANEL =
  "relative px-6 transform overflow-hidden rounded-lg dark:bg-slate-900 bg-slate-200 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95";

export const INPUT_CLASS =
  "block w-full rounded-md bg-slate-500/15 py-1.5 px-3 text-sm/6 focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-black/25";

export const SELECT_CLASS =
  "block w-full appearance-none rounded-md border-slate-500/25 bg-slate-500/15 py-1.5 px-3 text-sm/6 focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25 *:text-black";

export const SWITCH_CLASS =
  "group relative flex h-7 w-14 cursor-pointer rounded-full bg-slate-500/30 p-1.5 transition-colors duration-200 ease-in-out focus:outline-none data-[focus]:outline-1 data-[focus]:outline-white data-[checked]:bg-green-500/80";
